import { create } from 'zustand';

interface OnboardingItem {
  image: any;
  title: string;
  description: string;
  description2: string;
  description3: string;
}

interface AutoSwipeState {
  currentIndex: number;
  onboardingItems: OnboardingItem[];
  
  // Actions
  setCurrentIndex: (currentIndex: number) => void;
  nextSlide: () => void;
}

const useAutoSwipeStore = create<AutoSwipeState>((set) => ({
  currentIndex: 0,
  onboardingItems: [
    {
      image: null,
      title: "Welcome to Velarius Education",
      description: "Velarius Education the best study coach for you.",
      description2: "Plan Your Study Time!",
      description3: "Stay Organized with personalized schedules and reminders to keep you on track.",
    },
    {
      image: null,
      title: "Welcome to Velarius Education",
      description: "Velarius Education the best study coach for you.",
      description2: "Your AI Study Buddy",
      description3: "Chat with an AI assistant to get quick help, clear explanations.",
    },
    {
      image: null,
      title: "Welcome to Velarius Education ",
      description: "Personal Study Coach the best study coach for you.",
      description2: "Personalized Reminders",
      description3: "Get friendly reminders and tips to help you stay focused and keep studying.",
    },
  ],

  // Actions
  setCurrentIndex: (currentIndex) => set({ currentIndex }),
  nextSlide: () => set((state) => ({
    currentIndex: (state.currentIndex + 1) % state.onboardingItems.length
  })),
}));

export default useAutoSwipeStore;